import CBTPBTCommand from "./CBTPBTCommand";
import CBTPBTEditing from "./CBTPBTEditing";
import CBTPBTUI from "./CBTPBTUI";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class CBTPBT extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "CBTPBT";
  }

  static get requires() {
    return [CBTPBTCommand, CBTPBTUI, CBTPBTEditing];
  }
}
